import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import 'moment-timezone';
import * as moment from 'moment';

declare let CmKit: any;

/*
 Tools for use with UI needs
*/
@Injectable()
export class UiToolsProvider {
  constructor() {}

  private usersAvatar(user) {
    return (
      _.get(user, 'userImage') || 'assets/imgs/other-svg/default-avatar.svg'
    );
  }

  usersName(user) {
    let name;

    user = user || {};
    name = `${user.firstName || ''} ${user.lastName || ''}`.trim();

    if (_.size(name) > 32) {
      name = name.slice(0, 29) + '...';
    }

    return name;
  }

  usersHandle(user) {
    let handle;

    user = user || {};
    handle = `@${user.userNamePretty || ''}`.trim();

    if (_.size(handle) > 32) {
      handle = handle.slice(0, 29) + '...';
    }

    return handle;
  }

  usersStatusMessage(user) {
    let message;

    user = user || {};
    message = `${_.get(user, 'recentStatus.statusMessage') || ''}`;

    return message;
  }

  usersNextLocation(user) {
    let location;

    if (_.get(user, 'recentStatus.nextLocation')) {
      user = user || {};
      location = `${
        _.get(user, 'recentStatus.nextLocation.locationName') || ''
      }`;
    } else {
      location = '';
    }

    return location;
  }

  usersStatusExpiration(user) {
    let expires,
      expiresPretty,
      now = moment();
    // create date for next day
    let ref = now.clone().add(1, 'day');
    let setDate = _.get(user, 'recentStatus.statusExpirationDate');
    let eta = _.get(user, 'recentStatus.statusEta');

    user = user || {};
    expires = setDate ? moment(setDate) : '';
    if (expires) {
      // check if expiration date is tomorrow
      // if so add the month and day on the format
      if (expires.isSame(ref, 'd')) {
        expiresPretty = `${moment(eta).format('M/D h:mma')}-${moment
          .tz(expires, moment.tz.guess())
          .format('h:mma z')}`;
      } else {
        expiresPretty = `${moment(eta).format('h:mma')}-${moment
          .tz(expires, moment.tz.guess())
          .format('h:mma z')}`;
      }
    }
    return expiresPretty || expires;
  }

  actionSheetUserTitle(user) {
    const avatar = this.usersAvatar(user);
    return `
      <div class="cm-ListItem cm-Padding--remove-horizontal cm-Margin--bottom" >
        <div class="cm-ListItem-left">
          <div class="cm-Avatar" style="font-size: 38px">
            <img src="${avatar}" />
          </div>
        </div>
        <div class="cm-ListItem-middle">
          <div cm-font="Title / 14 Medium">
            ${this.usersName(user)}
          </div>
        </div>
      </div>
      <hr class="cm-Divider cm-Margin--bottom" />
    `;
  }

  actionSheetUserStatus(user) {
    const avatar = this.usersAvatar(user);
    const handle = this.usersHandle(user);
    const username = this.usersName(user);
    const message = this.usersStatusMessage(user);
    const location = this.usersNextLocation(user);
    const expires = this.usersStatusExpiration(user);
    const verified =
      _.get(user, 'states.verifiedStatus') === 'verified'
        ? `
      <span
        style="flex: 1; transform: translate(5px, 1px)"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 8C16 6.84375 15.25 5.84375 14.1875 5.4375C14.6562 4.4375 14.4688 3.1875 13.6562 2.34375C12.8125 1.53125 11.5625 1.34375 10.5625 1.8125C10.1562 0.75 9.15625 0 8 0C6.8125 0 5.8125 0.75 5.40625 1.8125C4.40625 1.34375 3.15625 1.53125 2.34375 2.34375C1.5 3.1875 1.3125 4.4375 1.78125 5.4375C0.71875 5.84375 0 6.84375 0 8C0 9.1875 0.71875 10.1875 1.78125 10.5938C1.3125 11.5938 1.5 12.8438 2.34375 13.6562C3.15625 14.5 4.40625 14.6875 5.40625 14.2188C5.8125 15.2812 6.8125 16 8 16C9.15625 16 10.1562 15.2812 10.5625 14.2188C11.5938 14.6875 12.8125 14.5 13.6562 13.6562C14.4688 12.8438 14.6562 11.5938 14.1875 10.5938C15.25 10.1875 16 9.1875 16 8ZM11.4688 6.625L7.375 10.6875C7.21875 10.8438 7 10.8125 6.875 10.6875L4.5 8.3125C4.375 8.1875 4.375 7.96875 4.5 7.8125L5.3125 7C5.46875 6.875 5.6875 6.875 5.8125 7.03125L7.125 8.34375L10.1562 5.34375C10.3125 5.1875 10.5312 5.1875 10.6562 5.34375L11.4688 6.15625C11.5938 6.28125 11.5938 6.5 11.4688 6.625Z"
            fill="#2E5FF6"
          />
        </svg>
      </span>
    `
        : ``;

    let html = `
      <div class="cm-Grid-row" style="justify-content: center">
        <div class="cm-Avatar" style="font-size: 50px">
          <img src="${avatar}" />
        </div>
      </div>
      <div class="cm-Grid-row cm-Margin--remove-vertical" style="justify-content: center">
        <div cm-font="Body / 14 Medium" style="display: flex;">
          ${username}
          ${verified}
        </div>
      </div>
      <div class="cm-Grid-row" style="justify-content: center">
        <div cm-font="Body / 12 Regular" cm-color="Neutral / Storm Grey">
          ${handle}
        </div>
      </div>
    `;

    // only add on the meet and greet information if there is a set expiration date
    if (expires) {
      html += `
        <div
          class="cm-Grid-row cm-Container"
          cm-background="Neutral / Athens Grey"
          style="justify-content: center; border-radius: 12px;"
        >
          <div
            class="cm-Padding cm-Text--break"
            cm-font="Body / 14 Regular"
            cm-color="Neutral / Mine Shaft"
          >
            ${message}
          </div>
        </div>
        <div class="cm-Grid-row">
          <i class="fas fa-map-marker-alt" style="margin: 0 9px 0 0;"></i>
          <span>${location}</span>
        </div>
        <div class-"cm-Grid-row">
          <i class="fas fa-clock" style="margin: 0 9px 0 0;"></i>
          <span>${expires}</span>
        </div>
      `;
    }

    return `
      <div class="cm-Grid cm-Margin--bottom">
        ${html}
      </div>
    `;
  }

  async actionSheetPrompt(opts) {
    opts = _.merge(
      {
        title: '',
        description: '',
        button: '',
        cancel: '',
      },
      opts
    );

    const res = await CmKit.ActionSheet({
      props: {
        templates: {
          title: `
              <div style="text-align:center">
                <div cm-font="Title / 20 Medium"
                     class="cm-Margin--bottom"
                     cm-color="Neutral / Mine Shaft">
                 ${opts.title}
                     </div>
                <div cm-font="Body 16 / Regular"
                     class="cm-Margin--bottom"
                     cm-color="Neutral / Mine Shaft">
                 ${opts.description}
                </div>
              </div>
              `,
          button: button => {
            return `
                <button class="cm-Button cm-Button--1 cm-Width-1-1"
                        cm-color="Primary / CDLLife Blue">
                 ${opts.button}
                </button>
                `;
          },
          cancel:
            opts.cancel &&
            `
              <div style="text-align:center"
                    cm-font="Button / 14 Regular"
                    class="cm-Margin--bottom"
                    cm-color="Neutral / Manatee">
                ${opts.cancel}
              </div>
              `,
        },
        buttons: [
          {
            text: opts.cancel,
          },
        ],
      },
    }).promise;

    return res;
  }
}



// WEBPACK FOOTER //
// ./src/providers/ui-tools/ui-tools.ts